import React from "react";
import styled from "@emotion/styled";
import { Colors } from "./components/colors";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import parse from "html-react-parser";

class Service extends React.Component {
  constructor(props) {
    // Initialize mutable state
    super(props);
    this.state = {
      placeholder: [],
    };
  }

  render() {
    // This line automatically assigns this.state.imgUrl to the const variable imgUrl
    // and this.state.owner to the const variable owner
    const { users } = this.state;
    // Render index

    return (
      <>
        <NavBar />
        <Servediv>
          <TermsContainer>
            <h2>Terms of Use</h2>
            <p><strong>Last Updated:</strong> November 21, 2024</p>

            <h3>1. About Our Services</h3>
            <p>
              Ratib.io provides a platform where users can anonymously post salary
              information and explore salary trends across various industries. Our goal
              is to provide valuable insights to help users make informed career decisions.
              All services on our site are free to use, and we do not charge any fees for
              accessing or using the platform.
            </p>

            <h3>2. User Conduct</h3>
            <p>
              By using our website, you agree not to:
              <ul>
                <li>Post false or misleading information.</li>
                <li>Engage in any harmful or unlawful activities, such as spamming, harassment, or impersonation.</li>
                <li>Upload or share content that violates intellectual property rights or is offensive.</li>
              </ul>
            </p>

            <h3>3. Data and Privacy</h3>
            <p>
              While we do not collect personally identifiable information by default, you acknowledge that any data
              you choose to post may be visible to other users of the platform. We encourage you to exercise caution
              when sharing information.

            </p>

            <h3>4. Content Accuracy</h3>
            <p>
              We strive to provide accurate and helpful information, but we do not guarantee the accuracy, completeness,
              or reliability of any content on the platform. All salary data is user-generated and should be used as a
              general reference.
            </p>

            <h3>5. No Warranty</h3>
            <p>
              Our website and services are provided "as is" without any warranties or guarantees. We do not guarantee
              uninterrupted access or error-free functionality.
            </p>

            <h3>6. Changes to Terms</h3>
            <p>
              We may update these terms from time to time. If we make significant changes, we will notify you by email
              or through an announcement on our website. Your continued use of the website after such changes constitutes
              your acceptance of the new terms.
            </p>

            <h3>7. Contact Us</h3>
            <p>
              If you have any questions or concerns about these terms or our services, please contact us at:
              <br />
              Email: <a href="mailto:contact@ratib.io">contact@ratib.io</a>
              <br />
              Phone: +966 545 402 2312
            </p>

          </TermsContainer>
        </Servediv>
        <Footer />
      </>
    );
  }
}

export default Service;

// Create a flex column display div
const Servediv = styled.div`
  padding: 1%;
  justify-content: space-between;
  background: ${Colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top:50px;
`;

const TermsContainer = styled.div`
  padding: 20px;
  background-color: ${Colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  h2 {
    font-size: 2rem;
    color: ${Colors.primary};
    margin-bottom: 20px;
  }

  h3 {
    font-size: 1.5rem;
    margin-top: 20px;
    color: ${Colors.primary};
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    color: ${Colors.text};
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
  }

  a {
    color: ${Colors.link};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

